import { NgModule } from '@angular/core';
import { SERVICES } from './services';


@NgModule({})
export class CoreModule {
  static forRoot() {
    return {
      ngModule: CoreModule,
      providers: [
        ...SERVICES
      ]
    };
  }
}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/core/core.module.ts